import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-loading-modal',
    templateUrl: './loading-modal.component.html',
    styleUrls: ['./loading-modal.component.scss'],
    standalone: false
})
export class LoadingModalComponent implements OnInit {
  @Input() data: string = "";
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
